export const parseStorageReport = value => {
  const initial = { amount: '', location: '' };
  if (typeof value !== 'string') return initial;
  const match = value.match(/Stored\s+(.+)\s+at\s+(.+)/);
  if (!match) return initial;
  return { amount: match[1], location: match[2] };
};

export const formatStorageReport = data =>
  data && data.amount && data.location ? `Stored ${data.amount} at ${data.location}` : null;
